<template>
  <div style="width:100%">
    <Header :title="$t('m.Register')"></Header>
    <div class="banner">
      <div class="stylebanner1" id="bannerMobile1"></div>
    </div>
    <div class="form">
      <div class="formitem">
        <input autocomplete='off' :placeholder="$t('m.PlsEnterMobileEmailLoginName')" style="border:none;outline:none" v-model="value1">
        <span @click="value1=''" class="icon" v-if="value1"><Icon class="color" type="ios-close-circle"></Icon></span>
      </div>
      <div class="formitem">
        <input :type="bool1?'password':'text'" :placeholder="$t('m.PlsEnterPass')" style="border:none;outline:none" v-model="value2">
        <span @click="booldo1" class="icon" v-if="value2"><Icon class="color" type="ios-eye" v-if="bool1"></Icon><Icon
          class="color" type="ios-eye-off" v-if="!bool1"></Icon></span>
      </div>
      <div class="formitem">
        <input :type="bool2?'password':'text'" autocomplete='off' :placeholder="$t('m.PlsEnterPassAgain')" style="border:none;outline:none"
               v-model="value3">
        <span @click="booldo2" class="icon" v-if="value3"><Icon class="color" type="ios-eye" v-if="bool2"></Icon><Icon
          class="color" type="ios-eye-off" v-if="!bool2"></Icon></span>
      </div>
      <div :class="{bgc:(value1&&value2&&value3),button:true}" @click="sub">{{$t('m.Register')}}</div>

    </div>
    <div class="logo">
      <div class="stylebanner2"></div>
    </div>
    <div class="modelwrap" v-if="model1">
      <div class="model">
        <div class="modeltitle">{{$t('m.RegisterOK')}}</div>
        <div @click="sure" class="modelact color">OK</div>
      </div>
    </div>
    <div class="modelwrap" v-if="model2">
      <div class="model">
        <div class="modeltitle">{{mes}}</div>
        <div @click="model2=false" class="modelact color">OK</div>
      </div>
    </div>
  </div>
</template>
<script>
  import Header from '../header/header'
  import {register} from '../../assets/js/url'

  export default {
    name: "login",
    data() {
      return {
        value1: "",
        value2: "",
        value3: "",
        mes: '',
        model1: false,
        model2: false,
        bool1: true,
        bool2: true
      }
    },
    components: {
      Header
    },
    activated() {
	  document.getElementById("bannerMobile1").style.background = 'url('+window.localStorage.getItem("bannerMobile")+') center center no-repeat';
	  document.getElementById("bannerMobile1").style.backgroundSize = '100% 100%';
    },
    methods: {
      booldo1() {
        this.bool1 = false;
        const _this = this
        setTimeout(function () {
          _this.bool1 = true
        }, 3000)
      },
      booldo2() {
        this.bool2 = false;
        const _this = this
        setTimeout(function () {
          _this.bool2 = true
        }, 3000)
      },
      sub() {
        const reg1 = /^1[34578]\d{9}$/
        const reg2 = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
        if (this.value1 && this.value2 && this.value3) {
		  /* 由后台校验
          if (this.value2 && this.value3) {
          const check = /[^\a-\z\A-\Z0-9]/.test(this.value2 && this.value3)
          if (check == true) {
            this.$toast("密码格式错误");
            return;
          }
          }*/
          if (this.value2 != this.value3) {
            this.mes = this.$t('m.TwicePassNotSame');
            this.model2 = true;
            return
          }
          this.$http.post(register, {
            registertype: reg1.test(this.value1) ? 1 : reg2.test(this.value1) ? 2 : 3,
            register_value: this.value1,
            password: this.value2,
            flat: 2,
			veriCode: "NO_NEED_CODE"
          }).then(
            res => {
              if (res.data.status == 2000) {
                this.model1 = true
              } else {
                this.mes = res.data.data.errorDes;
                this.model2 = true
              }

            },
            err => {
              console.log(err)
            }
          )
        } else {
          this.mes = this.$t('m.PlsFillAllInfo');
          this.model2 = true;

        }
      },
      sure() {
	    this.value1 = "";
		this.value2 = "";
		this.value3 = "";
        this.$router.push({path: "/login"});
        this.model2 = false;
        this.model1 = false
      }
    }
  }
</script>
<style scoped>
  .banner {
    margin-top: 0.3rem;
    width: 100%;
    height: 0.48rem;
    text-align: center;
  }

  .banner img {
    width: 2.3rem;
  }

  .form {
    margin: 0.30rem 0.30rem 0.20rem;
    height: 1.50rem;
    position: relative;
  }

  .hide {
    width: 0;
    height: 0;
    position: absolute;
    opacity: 0;
    top: -200px;
    left: 0;
  }

  .formitem {
    width: 100%;
    height: 0.5rem;
    background-color: #f6f7fa;
    border-radius: 3px;
    margin-top: 6px;
    box-sizing: border-box;
    padding: 0 0.15rem;
  }

  .formitem input {
    height: 0.5rem;
    width: 2.5rem;
    background-color: transparent;
    border: none;
    outline: none;
  }

  .formitem input:visited {
    border: none;
  }

  .formitem input:focus {
    border: none;
  }

  .formitem input:active {
    border: none;
  }

  .button {
    width: 100%;
    height: 0.44rem;
    background-color: #BEC9BC;
    border-radius: 3px;
    margin-top: 0.2rem;
    box-sizing: border-box;
    padding: 0 0.15rem;
    text-align: center;
    line-height: 0.44rem;
    font-size: 0.16rem;
    color: #fff;
  }

  .logo {
    margin-top: 1.5rem;
    width: 100%;
    height: 0.26rem;
    text-align: center;
  }

  .logo img {
    width: 1.01rem;
    height: 0.26rem;
  }

  i {
    font-size: 0.2rem;
    vertical-align: middle;
  }

  .icon {
    height: 0.5rem;
    line-height: 0.5rem;
    float: right;
  }

  .modelwrap {
    width: 100%;
    height: 100%;
    top: 0.44rem;
    left: 0px;
    position: fixed;
    background: rgba(0, 0, 0, .4)
  }

  .model {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -0.54rem;
    margin-left: -1.35rem;
    width: 2.70rem;
    height: 1.42rem;
    background-color: #fff;
    border-radius: 0.12rem;
    box-sizing: border-box;
    padding: 0.20rem 0.06rem;
  }

  .modeltitle {
    text-align: center;
    height: 0.68rem;
    line-height: 0.34rem;
    font-size: 0.17rem;
    color: #000;
  }

  .modelact {
    text-align: center;
    height: 0.34rem;
    line-height: 0.34rem;
    font-size: 0.17rem;
    color: #000;
  }
</style>




// WEBPACK FOOTER //
// src/components/login/register.vue